/** @jsx jsx */
import { jsx } from "theme-ui"
import Img from "gatsby-image"
import BGImage from "./bg-image"

const Hero = ({ children, image }) => (
  <section
    sx={{
      position: `relative`,
      height: [`350px`, `450px`],
      maxHeight: `1200px`,
      width: `100%`,
      overflow: `hidden`,
    }}
  >
    <BGImage>
      <Img fluid={image} />
    </BGImage>
    {children}
  </section>
)

export default Hero
